<template>
  
  <quillEditor
      :style="{height: contentHeight}"
      v-model="editorContent"
      :options="editorOptions"
      @change="contentChange"
    >
    </quillEditor>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
export default {
  components: {
    quillEditor,
  },
  data() {
    return {
      editorContent: '',
      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
            ['blockquote', 'code-block'],
            [{ 'list': 'ordered'}, { 'list': 'bullet' }],
            [{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
            [{ 'direction': 'rtl' }],                         // text direction

            [{ 'size': [false, 'large', 'huge'] }],  // custom dropdown
            [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

            [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
            [{ 'align': [] }],
          ]
        }
      }
    };
  },
  props: {
    content: {
      default: '',
    },
    contentHeight: {
      type: String,
      default: '300px',
    },
  },
  watch: {
    content: {
      immediate: true,
      handler() {
        this.editorContent = this.content;
      },
    }
  },
  methods: {
    contentChange() {
      this.$emit('update:content', this.editorContent);
    }
  }
}
</script>